import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2tfmqenqs6: FaireBrandEntity = {
  token: "b_2tfmqenqs6",
  type: "brand",
  name: "North Bay Candleworks",
  avatarUrl:
    "https://cdn.faire.com/fastly/8cf721aa0dc2a17c85f0172902993d71277b4c2d7ee049d82b5a304c92c65c7c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aefdfdf894f8db5b7137891b38038c9e65b96024e3a83565f51c2c86c386ad53.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8cf721aa0dc2a17c85f0172902993d71277b4c2d7ee049d82b5a304c92c65c7c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aefdfdf894f8db5b7137891b38038c9e65b96024e3a83565f51c2c86c386ad53.jpeg",
  location: "San Rafael, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "North Bay Candleworks grew out of a hobby from childhood. Influenced by his mother’s love for crafts, Doug started pouring candles at the age of 10 with her assistance. He has made candles throughout his life, giving them as gifts to family and friends. As a Registered Nurse in the emergency department, Doug has used his passion for making candles as a form of relaxation. With a love of his candles from co-workers and friends, his hobby has grown into a business which we call North Bay Candleworks, based in San Rafael, California. \n\nWe poured our first batch of candles for sale just before Thanksgiving 2018 after months of extensive testing. North Bay Candleworks candles are all hand-poured, one batch at a time. We use a soy and coconut wax blend and 100% cotton lead free wicks. \n\nDon't see a scent you're looking for? Message us!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.027Z",
    importedBy: "entity-db-cli",
  },
};
